/*eslint-disable*/ export const messages = JSON.parse("{\"textfield.label.optional\":[\"(valgfri)\"]}");
//# sourceMappingURL=messages.mjs.map